export default __webpack_public_path__ + "static/media/logo.4469a461.jpg";